import React from 'react'
import { carData as CData } from '../../../data/ParticularesCar.data';

import arrow from './../../../UI/canvas/carmenu/Tooltip_ocultar.svg'
import back from './../../../UI/canvas/carmenu/salir_interior_white.svg'

interface Props{
    carMenuOpened: boolean,
    selectedIndividual: string,
    handleShowInterior: any,
    handleShowSpin: any,
    handleShowVideo: any,
    handleShowBaul: any
    isVideo: boolean,
    canvasSelectedIndex: number
}

interface State{
    collapsed: boolean,
    carData: any,
    selectedIndex: number,
    selectedSubIndex: number
}

class CarMenu extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            collapsed: false,
            carData: CData()[0],
            selectedIndex: -1,
            selectedSubIndex: -1
        }
    }

    handleCollapseMenu = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        })
    }

componentDidUpdate(prevProps: any) {
   if( prevProps.selectedIndividual  !== "" && prevProps.selectedIndividual !== this.props.selectedIndividual){
    this.setState({selectedIndex: -1})
   }
    
}

    handleCreateMenuStructure = () => {
        
        return(
            this.state.carData[this.props.selectedIndividual].Menu.map((menuData: any, index: number) => {
                if(menuData.Slug === "interior" ){
                    return(
                        <>
                        <div className={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? 'general-btn-container-interior-selected':'general-btn-container-interior'}>
                        <div 
                            className={this.state.collapsed ?'data-container-collapsed':'data-container'} 
                            onClick = {() => {
                                this.setState({selectedIndex: this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? -1:index}, () => {
                                    if(!menuData.SubMenu){
                                        this.props.handleShowInterior(this.props.selectedIndividual+ " INTERIOR", this.state.selectedIndex)
                                    }
                                })
                            }}
                        >
                            <img src={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? menuData.Icono2.default:menuData.Icono.default}></img>
                            {
                                !this.state.collapsed ?
                                <div className={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? "selected-carmenu-text":""}>{this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? "Quiero Salir":menuData.Nombre}</div>:null
                            }
                        </div>
                        {
                            this.state.selectedIndex === index && menuData.SubMenu ?
                            <div className='subdata-container'>
                                {
                                    menuData.SubMenu.map((submenu: any, indexSub: number) => 
                                        <div className='subdata-btn' 
                                        onClick={() => {
                                            this.setState({
                                                selectedSubIndex: this.state.selectedSubIndex === indexSub && this.props.canvasSelectedIndex === index ? -1:indexSub
                                            }, () => {this.props.handleShowInterior(this.props.selectedIndividual + " "+ submenu.Nombre, this.state.selectedSubIndex)})
                                        }}>
                                            {submenu.Nombre}
                                        </div>
                                    )
                                }
                            </div>:null
                        }
                    </div>
                    </>
                    )
                }
                if(menuData.Slug === "baul"){
                    return(
                        <>
                        <div className={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? 'general-btn-container-interior-selected':'general-btn-container-interior'}>
                        <div 
                            className={this.state.collapsed ?'data-container-collapsed':'data-container'} 
                            onClick = {() => {
                                this.setState({selectedIndex: this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? -1:index}, () => {
                                    if(!menuData.SubMenu){
                                        this.props.handleShowBaul(this.props.selectedIndividual+ " BAUL", this.state.selectedIndex)
                                    }
                                })
                            }}
                        >
                            <img src={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? menuData.Icono2.default:menuData.Icono.default}></img>
                            {
                                !this.state.collapsed ?
                                <div className={this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? "selected-carmenu-text":""}>{this.state.selectedIndex === index && this.props.canvasSelectedIndex === index ? "Quiero Salir":menuData.Nombre}</div>:null
                            }
                        </div>
                        {
                            this.state.selectedIndex === index && menuData.SubMenu ?
                            <div className='subdata-container'>
                                {
                                    menuData.SubMenu.map((submenu: any, indexSub: number) => 
                                        <div className='subdata-btn' 
                                        onClick={() => {
                                            this.setState({
                                                selectedSubIndex: this.state.selectedSubIndex === indexSub && this.props.canvasSelectedIndex === index ? -1:indexSub
                                            }, () => {this.props.handleShowBaul(this.props.selectedIndividual + " "+ submenu.Nombre, this.state.selectedSubIndex)})
                                        }}>
                                            {submenu.Nombre}
                                        </div>
                                    )
                                }
                            </div>:null
                        }
                    </div>
                    </>
                    )
                }
                if(menuData.Slug === "360"){
                    return(
                        <>
                        <div className={this.state.selectedIndex === index  && this.props.canvasSelectedIndex === index ? 'general-btn-container-interior-selected':'general-btn-container-interior'}>
                        <div 
                            className={this.state.collapsed ?'data-container-collapsed':'data-container'} 
                            onClick = {() => {
                                this.setState({selectedIndex: this.state.selectedIndex === index  && this.props.canvasSelectedIndex === index ? -1:index}, () => {this.props.handleShowSpin(this.state.selectedIndex)})
                            }}
                        >
                            <img src={this.state.selectedIndex === index  && this.props.canvasSelectedIndex === index ? menuData.Icono2.default:menuData.Icono.default}></img>
                            {
                                !this.state.collapsed ?
                                <div className={this.state.selectedIndex === index  && this.props.canvasSelectedIndex === index ? "selected-carmenu-text":""}>{menuData.Nombre}</div>:null
                            }
                        </div>
                    </div>
                    </>
                    )
                }
                if(menuData.Slug === "ficha" || menuData.Slug === "cotiza" || menuData.Slug === "testdrive"){
                    return(
                        <div className={this.state.selectedIndex === index  && this.props.canvasSelectedIndex ? 'general-btn-container-interior-selected':'general-btn-container-interior'}>
                            <a href={menuData.URL} target={"_blank"}>
                                <div 
                                    className={this.state.collapsed ?'data-container-collapsed':'data-container'} 
                                    onClick = {() => {
                                        this.setState({selectedIndex: this.state.selectedIndex === index  && this.props.canvasSelectedIndex ? -1:index}, () => {})
                                    }}
                                >
                                    <img src={this.state.selectedIndex === index  && this.props.canvasSelectedIndex ? menuData.Icono2.default:menuData.Icono.default}></img>
                                    {
                                        !this.state.collapsed ?
                                        <div className={this.state.selectedIndex === index  && this.props.canvasSelectedIndex ? "selected-carmenu-text":""}>{menuData.Nombre}</div>:null
                                    }
                                </div>
                            </a>
                        </div>
                    )
                }
                if(menuData.Slug === "promocionales" || menuData.Slug === "testimoniales"){
                    return(
                        <div className={this.state.selectedIndex === index && this.props.canvasSelectedIndex && this.props.isVideo ? 'general-btn-container-interior-selected':'general-btn-container-interior'}>
                        <div 
                            className={this.state.collapsed ?'data-container-collapsed':'data-container'} 
                            onClick = {() => {
                                this.setState({selectedIndex: this.state.selectedIndex === index  && this.props.canvasSelectedIndex ? -1:index}, () => {this.props.handleShowVideo(this.state.selectedIndex === index ? this.state.selectedIndex:menuData.URL, menuData.URL)})
                            }}
                        >
                             <img src={this.state.selectedIndex === index  && this.props.canvasSelectedIndex && this.props.isVideo ? menuData.Icono2.default:menuData.Icono.default}></img>
                            {
                                !this.state.collapsed ?
                                <div className={this.state.selectedIndex === index  && this.props.canvasSelectedIndex && this.props.isVideo ? "selected-carmenu-text":""}>{menuData.Nombre}</div>:null
                            }
                        </div>
                    </div>
                    )
                }
            })
        )
    }

    render(): React.ReactNode {
        return(
            
            <div className={this.props.carMenuOpened ? this.state.collapsed ? "carmenu-main-collapsed":"carmenu-main fade-in": "carmenu-main fade-out"}>
                <div className='car-menu-header'>
                    <div className='collapse-btn' onClick={() => {this.handleCollapseMenu()}}>
                        <img src={arrow}/>
                    </div>
                    {!this.state.collapsed ? 
                    <div className='header-name'>
                        <p onChange={() => {console.log("cambioo")}}>{this.props.selectedIndividual}</p>
                    </div>:null
                }
                </div>
                <div className='carmenu-container'>
                    {
                        this.props.selectedIndividual !== "" ?  
                        this.handleCreateMenuStructure():null
                    }
                </div>
            </div>
        )
    }
}

export default CarMenu